// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledRootErrorBoundary = styled('div')(
  () => css`
    .error-boundary {
      display: flex;
      align-items: center;
      flex-direction: column;
      font-family: inherit;
      padding: 16px;
      overflow-y: auto;
      overflow-x: hidden;
      .image {
        margin-top: 100px;
        width: 250px;
        height: 264px;
      }
      .title {
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin: 22px 0;
      }

      .error-toggler {
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        margin-top: 16px;
        color: #199da3;
        display: flex;
        cursor: pointer;
      }
      .stack {
        padding: 16px;
        background: #eee;
        direction: ltr;
        width: 100%;
        max-width: 700px;
        overflow-x: auto;
        user-select: text;
      }
    }
  `
);
